













































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import DataPenunjang from "@/services/DataPenunjang";
import { storePenunjang } from "@/store/modules/penunjang";
import TemplateOrderPenunjang from "@/services/TemplateOrderPenunjang";

@Component({})
export default class CardListTemplatePenunjang extends Vue {
  @Prop() title: string;
  @Prop() category: string;
  @Prop() orderItems: Array<object>;
  @Prop() assign: string;
  @Prop() showed: boolean;
  nama = "";
  preview: {
    id: number;
    category: string;
    nama: string;
    items: [];
    type: string;
  } = null;
  showList = true;
  selected = null;
  highlighted = null;
  page = 1;
  items = [];
  aktifItems = [];
  // pageLength = 5;
  //   public listTemplate = [];
  removing = false;

  close() {
    this.$emit("close-modal");
  }

  mounted() {
    // this.mode = null;
    if (this.assign === "list") {
      this.showList = true;
    } else if (this.assign === "input") {
      this.showList = false;
    }
    // this.listTemplate = [];
    this.resetPreview();
  }
  btnListColor(btnIndex) {
    return this.selected === btnIndex
      ? "grey"
      : this.highlighted === btnIndex
      ? "light-grey"
      : "default";
  }

  // get items() {
  //   return this.orderItems;
  // }
  get arrayOrder() {
    let arrOrder = [];
    if (this.orderItems) {
      arrOrder = this.orderItems.map(item => item["id"]);
    }
    return arrOrder;
  }

  get listTemplate() {
    return storePenunjang.template
      ? {
          paket: storePenunjang.template.paket.map(item => {
            item.type = "paket";
            return item;
          }),
          user: storePenunjang.template.user.map(item => {
            item.type = "user";
            return item;
          })
        }
      : null;
  }

  get loadingListTemplate() {
    return storePenunjang.loadingTemplate;
  }

  getListTemplate() {
    storePenunjang.act_template_penunjang(this.category);
  }
  // get mode() {
  //   return this.assign;
  // }
  // set mode(val) {
  //   this.assign = val;
  // }
  // @Watch("mode")
  // changedMode(val: string) {
  //   console.log(val);
  //   if (val === "list") {
  //     this.showList = true;
  //   } else if (val === "input") {
  //     this.showList = false;
  //   }
  // }
  @Watch("showList")
  changedShowList(show: boolean) {
    if (!show) {
      this.nama = "";
      this.orderItems = [];
    }
  }
  @Watch("showed")
  changedShowed(status: boolean) {
    // console.log("sts", status);
    if (status) {
      if (this.showList) {
        this.getListTemplate();
        // this.listTemplate = storePenunjang.template;
      } else if (!this.showList) {
        this.items = this.orderItems;
      }
      // this.listTemplate = this.masterListTemplate;
    } else {
      //   this.listTemplate = [];
      this.showList = true;
      this.resetPreview();
      this.highlighted = null;
    }
  }
  previewItem(item) {
    this.aktifItems = [];
    // console.log(item.items);
    item.items.forEach(val => {
      if (val.aktif === true) {
        this.aktifItems.push(val);
      }
    });
    this.selected = item.id;
    this.preview = item;
  }
  saveTemplate() {
    const dt = DataPenunjang.saveDataTemplate(
      this.nama,
      this.category,
      this.arrayOrder
    );
    dt.then(dt => {
      appModule.setLoading(false);
      if (dt["status"] != 1) {
        // appModule.sendErrorAlert(dt["err"]);
        // console.log("gagal");
      } else {
        appModule.NoticeDelay("Berhasil Membuat Template");
        this.close();
        // console.log("berhasil");
      }
    });
  }
  addItem() {
    this.$emit("assign-penunjang-template", this.aktifItems);
  }
  resetPreview() {
    this.preview = null;
  }
  @Watch("assign")
  changedAssign(val: string) {
    if (val === "list") {
      this.showList = true;
    } else if (val === "input") {
      this.showList = false;
      this.$nextTick(function() {});
    }
  }

  confirmRemove() {
    return confirm("Anda yakin menghapus template order ini?");
  }

  async removeTemplate(id) {
    if (this.confirmRemove()) {
      if (!this.removing) {
        this.removing = true;

        TemplateOrderPenunjang.destroy(id)
          .then(dt => {
            if (dt.status) {
              appModule.NoticeDelay("Berhasil Menghapus Template");

              this.resetPreview();
              this.getListTemplate();
            }
          })
          .finally(() => {
            this.removing = false;
          });
      }
    }
  }
}
